export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/b2a93f56e0b61c8c299de974eace83e3.jpg"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/92 via-navy-800/88 to-navy-900/92"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="animate-fade-in">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-bold text-white mb-8 leading-tight tracking-tight">
            ASSET AND BUSINESS<br />
            SUPPORT SERVICES<br />
            <span className="text-white">BUILT FOR GROWTH.</span><br />
            <span className="text-white">BACKED BY EXPERIENCE.</span>
          </h1>

          <p className="text-xl md:text-2xl text-grey-200 mb-12 max-w-4xl mx-auto font-light leading-relaxed">
            General Business • Property Support • Automotive • Asset Management
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-10 py-5 bg-navy-700 text-white rounded-lg hover:bg-navy-600 transition-all cursor-pointer font-semibold text-lg shadow-xl whitespace-nowrap hover:scale-105 transform"
            >
              Request Information
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="px-10 py-5 bg-transparent border-2 border-grey-400 text-white rounded-lg hover:bg-grey-700 hover:border-grey-500 transition-all cursor-pointer font-semibold text-lg whitespace-nowrap hover:scale-105 transform"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-grey-300 text-3xl"></i>
      </div>
    </section>
  );
}
